<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <form @submit.prevent="submit" class="card-body">
        <div class="row">
          <div
            v-if="getPermission(1050).view | getPermission(1070).view"
            :class="(getPermission(1050).view | getPermission(1120).view | !this.$store.state.currentUserInfo.isCompanyUser) ? 'col-md-6' : ''"
            >
            <label class="form-control-label">شرکت</label>
            <treeselect
              v-model="companyId"
              :multiple="false" :disabled="(!getPermission(1050).view)"
              :placeholder="(customerId || !companyId) ? '' : companyTitle"
              :showCount="true"
              noOptionsText="هنوز شرکتی تعریف نشده است"
              noResultsText="موردی یافت نشد"
              noChildrenText="این شرکت فاقد زیر مجموعه است"
              :options="companies"
              @open="reloadCompanies"
              :class="(getPermission(1050).view | getPermission(1120).view | !this.$store.state.currentUserInfo.isCompanyUser) ? '' : 'col-md-6'"
              />
          </div>
          <div
            v-if="getPermission(1050).view | getPermission(1120).view"
            :class="(getPermission(1050).view | getPermission(1070).view) ? 'col-md-6' : ''"
            >
            <label class="form-control-label">مشتری</label>
            <treeselect
              v-model="customerId"
              :multiple="false"
              :placeholder="customerId ? customerTitle : ''"
              :showCount="true"
              noOptionsText="هنوز مشتری ای تعریف نشده است"
              noResultsText="موردی یافت نشد"
              noChildrenText="این مشتری فاقد زیر مجموعه است"
              :options="customers"
              @open="reloadCustomers"
              :class="(getPermission(1050).view | getPermission(1070).view) ? '' : 'col-md-6'"
              />
          </div>
          <div class="col-md-6">
            <label class="form-control-label required" for="firstName">نام</label>
            <input class="form-control" type="text" id="firstName" name="firstName" v-model.trim="firstName" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label required" for="lastName">نام خانوادگی</label>
            <input class="form-control" type="text" id="lastName" name="lastName" v-model.trim="lastName" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label required" for="userName">کد ملی</label>
            <input class="form-control" type="text" id="username" name="username" v-model.trim="username" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label required" for="postTitle">سمت</label>
            <input class="form-control" type="text" id="postTitle" name="postTitle" v-model.trim="postTitle" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label required" for="phone">موبایل</label>
            <input class="form-control" type="text" id="phone" name="phone" v-model.trim="phone" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label" for="email">ایمیل</label>
            <input class="form-control" type="text" id="email" name="email" v-model.trim="email" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label" for="workPhone">تلفن محل کار</label>
            <input class="form-control" type="text" id="workPhone" name="workPhone" v-model.trim="workPhone" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label" for="workPhoneInternalCode">داخلی</label>
            <input class="form-control" type="text" id="workPhoneInternalCode" name="workPhoneInternalCode" v-model.trim="workPhoneInternalCode" />
          </div>
          <div class="col-md-6">
            <label for="gender" class="form-label required">جنسیت</label>
            <vue-select v-model="gender" :options="genders" dir="rtl" label="value">
              <template #no-options="{ search, searching, loading }">
                موردی یافت نشد!
              </template>
            </vue-select>
          </div>
          <div class="col-md-6">
            <label class="form-control-label" for="dateOfBirth">تاریخ تولد</label>
            <custom-date-picker :selectedDate="dateOfBirth" @update:selectedDate="setDate" />
          </div>
          <div class="col-md-6" v-if="new">
            <label class="form-control-label required" for="UFPassword">رمز عبور</label>
            <input class="form-control" type="password" id="UFPassword" name="UFPassword" v-model.trim="password"
              autocomplete="new-password" />
          </div>
          <div class="col-md-6" v-if="new">
            <label class="form-control-label required" for="UFRePassword">تکرار رمز عبور</label>
            <input class="form-control" type="password" id="UFRePassword" name="UFRePassword"
              v-model.trim="rePassword" />
          </div>
          <div class="form-check">
            <hr class="horizontal dark" />
            <input class="form-check-input" type="checkbox" v-model="isActive" id="isActive">
            <label class="form-check-label" for="isActive">کاربر فعال</label>
          </div>
          <div v-if="customerId" class="form-check">
            <hr class="horizontal dark" />
            <input class="form-check-input" type="checkbox" v-model="isAdmin" id="isAdmin">
            <label class="form-check-label" for="isAdmin">کاربر ادمین</label>
          </div>
        </div>
        <hr class="horizontal dark" />
        <template v-if="v.$error">
          <show-errors :model-value="v.$errors"></show-errors>
          <hr class="horizontal dark" />
        </template>
        <div>
          <button class="btn bg-gradient-success mb-0" type="submit">ثبت</button>
          <button class="btn bg-gray-400 me-3 float-start mb-0" type="button" @click="goBack">بازگشت</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import UserService from '@/services/User/User-service.js';
import { maxLength, sameAs, helpers, requiredIf, required, minLength, numeric, email } from '@vuelidate/validators';
import Treeselect from '@cholakovdev/vue3-treeselect';
import CustomDatePicker from '../components/CustomDatePicker.vue';
import { mapGetters } from "vuex";

export default {
  components: { Treeselect, CustomDatePicker },
  data() {
    return {
      v: this.$useVuelidate(),
      userId: null,
      postTitle: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      workPhone: '',
      workPhoneInternalCode: '',
      username: '',
      password: '',
      rePassword: '',
      companies: [],
      companyId: null,
      customers: [],
      customerId: null,
      isAdmin: false,
      isActive: false,
      new: true,
      oldId: null,
      companyTitle: '',
      customerTitle: '',
      genders: [
        {key : 0, value : "نا مشخص"},
        {key : 1, value : "مرد"},
        {key : 2, value : "زن"},
      ],
      gender: {},
      dateOfBirth: null,
    };
  },
  computed: {
    ...mapGetters(['getPermission']),
  },
  watch: {
    companyId(companyId) {
      if (typeof (companyId) === 'number' && typeof (this.customerId) === 'number' && this.getPermission(1050).view) {
        this.customers = [{ id: this.customerId, label: '', pH: true }];
        this.oldId = this.customerId;
        this.customerId = null;
        this.isAdmin = false;
      }
    },
    customerId(customerId) {
      if (typeof (customerId) === 'number' && typeof (this.companyId) === 'number' && this.getPermission(1050).view) {
        this.companies = [{ id: this.companyId, label: '', pH: true }];
        this.oldId = this.companyId;
        this.companyId = null;
      }
    },
  },
  methods: {
    submit() {

      this.v.$validate();
      if (this.v.$error) {
        return;
      }

      let user = {
        Id: this.userId ?? 0,
        PostTitle: this.postTitle,
        FirstName: this.firstName,
        LastName: this.lastName,
        Email: this.email ?? '',
        Phone: this.phone,
        workPhone: this.workPhone,
        workPhoneInternalCode: this.workPhoneInternalCode,
        Username: this.username,
        CompanyId: this.companyId,
        CustomerId: this.customerId,
        IsActive: this.isActive,
        IsAdmin: this.isAdmin,
        gender: this.gender.key,
        dateOfBirth: this.dateOfBirth,
        Password: this.password,
        RePassword: this.rePassword,
      };

      if (!this.new) {

        UserService.update(user).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          } else {
            this.$toast.success(result.message);

            setTimeout(() => this.$router.back(), 500);
          }
        }).catch(e => {
          console.log(e);
        });
      }
      else {
        UserService.create(user).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          } else {
            this.$toast.success(result.message);

            setTimeout(() => this.$router.back(), 500);
          }
        }).catch(e => {
          console.log(e);
        });

        this.v.$reset();
      }
    },
    getUser() {
      UserService.find(this.userId).then(response => {
        let result = response.data;

        if (result.success) {
          this.postTitle = result.data.postTitle;
          this.firstName = result.data.firstName;
          this.lastName = result.data.lastName;
          this.email = result.data.email;
          this.phone = result.data.phone;
          this.workPhone = result.data.workPhone;
          this.workPhoneInternalCode = result.data.workPhoneInternalCode;
          this.username = result.data.username;
          this.companyId = result.data.customerId ? null : result.data.companyId;
          this.companyTitle = result.data.companyTitle;
          this.customerTitle = result.data.customerTitle;
          setTimeout(() => { this.customerId = result.data.customerId; }, 250);
          this.isAdmin = result.data.isAdmin;
          this.isActive = result.data.isActive;
          this.password = "12345";
          this.rePassword = "12345";
          this.gender = this.genders[this.genders.map(x => x.key).indexOf(result.data.gender)];
          this.dateOfBirth = result.data.dateOfBirth;
          //console.log(result.data);
          //if (this.companyId) {
          //  //this.companies.push(this.$store.state.currentUserInfo.companies);
          //  this.companies = [{ id: this.companyId, label: result.data.companyTitle, pH: true }];
          //  this.customers = this.$store.state.currentUserInfo.customers;
          //}
          //else {
          //  //this.customers.push(this.$store.state.currentUserInfo.customers);
          //  this.customers = [{ id: this.customerId, label: result.data.customerTitle, pH: true }];
          //}
        } else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    goBack() {
      this.$router.back();
    },
    reloadCompanies() {
      if (this.companies[0].pH && this.getPermission(1050).view) {
        this.companyId = this.oldId;
        this.companies = [];
        this.companies.push(this.$store.state.currentUserInfo.companies);
      }
    },
    reloadCustomers() {
      if (this.customers[0].pH && this.getPermission(1050).view) {
        this.customerId = this.oldId;
        this.customers = [];
        this.customers = this.$store.state.currentUserInfo.customers;
      }
    },
    setDate(date) {
      this.dateOfBirth = date ? (date.slice(0, 4) + date.slice(5, 7) + date.slice(8, 10)) : null;
    },
  },
  created() {
    this.new = this.$route.meta.new;

    if (this.$store.state.currentUserInfo.companies) {
      this.companies.push(this.$store.state.currentUserInfo.companies);
      this.customers = this.$store.state.currentUserInfo.customers;
      if (this.new & (this.getPermission(1050).view | this.getPermission(1070).view)) {
        this.companyId = this.$store.state.currentUserInfo.companies.id;
      }
    }
    else {
      this.customers.push(this.$store.state.currentUserInfo.customers);
      if (this.new) { this.customerId = this.$store.state.currentUserInfo.customers.id; }
    }

    if (!this.new) {
      this.userId = this.$route.params.userId;
      this.getUser();
    }
  },
  validations() {
    let valObj = {
      customerId: {
        requiredIf: helpers.withMessage('لطفا "شرکت" یا "مشتری" مربوطه را انتخاب کنید', requiredIf(!this.companyId)),
      },
      firstName: {
        required: helpers.withMessage('لطفا "نام" را وارد کنید', required),
        maxLength: helpers.withMessage('حد‌اکثر طول مجاز برای "نام"، 50 کاراکتر است', maxLength(50)),
      },
      lastName: {
        required: helpers.withMessage('لطفا "نام خانوادگی" را وارد کنید', required),
        maxLength: helpers.withMessage('حد اکثر طول مجاز برای "نام خانوادگی"، 50 کاراکتر است', maxLength(50)),
      },
      postTitle: {
        required: helpers.withMessage('لطفا "سمت" را وارد کنید', required),
        maxLength: helpers.withMessage('حد اکثر طول مجاز برای "سمت"، 100 کاراکتر است', maxLength(100)),
      },
      username: {
        required: helpers.withMessage('لطفا "کد ملی" را وارد کنید', required),
        maxLength: helpers.withMessage('"کد ملی" باید شامل 10 رقم باشد', maxLength(10)),
        minLength: helpers.withMessage('"کد ملی" باید شامل 10 رقم باشد', minLength(10)),
        numeric: helpers.withMessage('"کد ملی" فقط باید شامل عدد باشد', numeric),
      },
      phone: {
        required: helpers.withMessage('لطفا "موبایل" را وارد کنید', required),
        maxLength: helpers.withMessage('حد اکثر طول مجاز برای "موبایل"، 50 کاراکتر است', maxLength(50)),
      },
      workPhone: {
        maxLength: helpers.withMessage('حد اکثر طول مجاز برای "تلفن محل کار"، 20 کاراکتر است', maxLength(20)),
      },
      workPhoneInternalCode: {
        maxLength: helpers.withMessage('حد اکثر طول مجاز برای "داخلی"، 20 کاراکتر است', maxLength(20)),
      },
      email: {
        //required: helpers.withMessage('لطفا "ایمیل" را وارد کنید', required),
        email: helpers.withMessage('"ایمیل" معتبر نیست', email),
        maxLength: helpers.withMessage('حد اکثر طول مجاز برای "ایمیل"، 250 کاراکتر است', maxLength(250)),
      },
      gender: {
        required: helpers.withMessage('لطفا "جنسیت" را مشخص کنید', required)
      },
      password: {
        required: helpers.withMessage('لطفا "رمز عبور" را وارد کنید', required),
        maxLength: helpers.withMessage('حد اکثر طول مجاز برای "رمز عبور"، 50 کاراکتر است', maxLength(50)),
        minLength: helpers.withMessage('"رمز عبور" باید حداقل شامل 5 کاراکتر باشد', minLength(5)),
      },
      rePassword: {
        sameAsPassword: helpers.withMessage('"تکرار رمز عبور" با "رمز عبور" تفاوت دارد', sameAs(this.password)),
      },
    };

    return valObj;
  },
}
</script>